import axios from "axios"
import { BASE_URL } from "../index"

export const getUsers = async () => {
    const response = await axios.get(
        `${BASE_URL}/PowerMeter/GetUserDetails`
    );

    return response.data;
};

export const getUserById = async (serviceNumber) => {
    const response = await axios.get(
        `${BASE_URL}/PowerMeter/GetUserDetails?serviceNumber=${serviceNumber}`
    );

    return response.data;
}

export const createUser = async (payload) => {
    const {
        ServiceNumber,
        Name,
        MobileNumber,
        Role,
        Status,
        Password,
        CreatedBy,
        DepartmentCode
    } = payload;

    const response = await axios.post(
        `${BASE_URL}/PowerMeter/PostUser`,
        null,
        {
            params: {
                ServiceNumber,
                Name,
                MobileNumber,
                Role,
                Status,
                Password,
                CreatedBy,
                DepartmentCode
            }
        }
    );

    return response.data;
}